import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const CustomBreadcrumbs = () => {
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator=">"
      sx={{ fontSize: 18, fontFamily: "Poppins", color: "#000000" }}
    >
      <Link to="/" color="#000000" style={{ textDecoration: "none" }}>
        Accueil
      </Link>
      <Typography
        sx={{ fontSize: 18, fontFamily: "Poppins", color: "#000000" }}
      >
        Pré-commande
      </Typography>
    </Breadcrumbs>
  );
};

export default CustomBreadcrumbs;
